import React, { lazy } from 'react';
import { CONSTANTS } from '../utils/constants';
import { BookOpen } from 'lucide-react';
export const WhatIsIncluded: React.FC = () => {
  return <section className="py-16 bg-white" data-id="element-346">
      <div className="max-w-4xl mx-auto px-4" data-id="element-347">
        <div className="text-center mb-12" data-id="element-348">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-349">
            ¿Qué incluye exactamente?
          </h2>
        </div>

        <div className="bg-gradient-to-br from-blue-50 to-sky-100 rounded-3xl p-8 md:p-12 border border-blue-200 shadow-lg relative overflow-hidden" data-id="element-350">
          <div className="absolute top-0 right-0 bg-blue-600 text-white px-6 py-2 rounded-bl-2xl font-bold text-sm tracking-wider uppercase shadow-md" data-id="element-351">
            Producto Principal
          </div>

          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-352">
            <div className="w-full md:w-1/2 relative" data-id="element-353">
              <img src={CONSTANTS.PRODUCT_IMAGE} alt="Ebook Principal" className="w-full h-auto drop-shadow-xl rounded-lg" loading="lazy" data-id="element-354" />
            </div>

            <div className="w-full md:w-1/2 space-y-6" data-id="element-355">
              <div className="flex items-center space-x-3 text-blue-600 mb-2" data-id="element-356">
                <BookOpen className="w-6 h-6" data-id="element-357" />
                <span className="font-bold uppercase tracking-wider text-sm" data-id="element-358">
                  Ebook Digital
                </span>
              </div>

              <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900 leading-tight" data-id="element-359">
                Ebook para Profesores de Gimnasia Artística Infanto-Juvenil
              </h3>

              <p className="text-lg text-gray-700 font-medium leading-relaxed" data-id="element-360">
                Plan de entrenamiento completo listo para usar con ejercicios
                progresivos organizados por nivel y aparato.
              </p>

              <div className="pt-4 border-t border-blue-200" data-id="element-361">
                <p className="text-sm text-gray-500 uppercase font-bold tracking-wider mb-1" data-id="element-362">
                  Valor Normal
                </p>
                <p className="text-3xl font-black text-gray-900" data-id="element-363">
                  {CONSTANTS.PRICES.SALE} ARS
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};